//#region IMPORT
import React from 'react';
import {
  Stack as MuiStack,
  Card as MuiCard,
  Button as MuiButton,
  Box as MuiBox,
  Unstable_Grid2 as Grid,
  Stack,
  TextField,
  Box,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
  Chip,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
  Divider,
  Slide,
} from '@mui/material';
import {
  Search as SearchIcon,
  Add as AddIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Print as PrintIcon,
  DriveFolderUpload as FileUploadIcon,
  Refresh as RefreshIcon,
  Copyright as CopyrightIcon,
} from '@mui/icons-material';
import {
  AuthButton,
  Button,
  DatePicker,
  Dialog,
  Combo,
  Checkbox,
  GroupCheckbox,
  Radio,
  FRadio,
} from '../../Components/MUIs';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import { AgGridReact } from 'ag-grid-react';
import Commons from '../../Services/Common/Common';
//#endregion

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function ExcelGridCommon({
  gridRef,
  columnDefs,
  rowData,
  setSelectedRowData,
  setChangedRowData,
  editable = false,
  onSelectionChanged,
  onCellValueChanged,
  onCellClicked,
  autoGroupColumnDef = {},
  rowSelection='single',
}) {
  const [dialogToggle1, setDialogToggle1] = React.useState({
    open: false,
    title: '',
    content: <></>,
    contentText: '',
    actions: <></>,
  });

  const gridOptions = {
    rowClassRules: {
      'new-row': (params) => params.data && params.data.newYn === 'Y', // params.data가 존재하는지 확인 후 처리
      'delete-row': (params) => params.data && params.data.deleteYn === 'Y',
      'edit-row': (params) =>
        params.data && params.data.editYn === 'Y' && params.data.newYn !== 'Y',
    },
  };

  return (
    <div style={{ height: 0, width: 0, overflow: 'hidden' }}>
      <div className="ag-theme-alpine" style={{ height: 1, width: 1 }}>
        <AgGridReact ref={gridRef} columnDefs={columnDefs} rowData={rowData} rowSelection={rowSelection} />
      </div>
    </div>
  );
}

export default ExcelGridCommon;
